module.exports = __webpack_public_path__ + "img/wh4.d76a4a8b.png";